export const events = {
  ANALYSIS_FINISHED: 'uf.analysis.finished',
  ANALYSIS_ERROR: 'uf.analysis.error',
};
